export const MEDIA_LIBRARY_INVALIDATE_EVENT = 'contentgen:media-library-invalidated';

export interface MediaLibraryInvalidateDetail {
  eventType: string;
  mediaId?: string;
}

export const notifyMediaLibraryInvalidated = (detail: MediaLibraryInvalidateDetail): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<MediaLibraryInvalidateDetail>(MEDIA_LIBRARY_INVALIDATE_EVENT, { detail }));
};
